export default "__VITE_ASSET__CDIW95VM__"